import { useLanguage } from './language-context'
import { getTranslation, type TranslationKey } from './translations'

export function useTranslation() {
    const { locale } = useLanguage()
    
    const t = (key: TranslationKey): string => {
        return getTranslation(locale, key)
    }
    
    return { t, locale }
}

